import { z } from 'zod';
export const HOME_TILE_KEYS = [
    'booking',
    'menu',
    'parking',
    'about',
    'director',
];
export const homeTileKeySchema = z.enum(HOME_TILE_KEYS);
export const homeTileDtoSchema = z.object({
    key: homeTileKeySchema,
    imageUrl: z.string().url().nullable(),
});
export const updateHomeTileSchema = z.object({
    imageUrl: z.string().url().nullable(),
});
